/** Metadatos UI de perfiles recomendados (claves i18n bajo `permissions.profile_*`). */

export const RECOMMENDED_PROFILES = [
  { id: 'hr_team', tone: 'accent' },
  { id: 'area_manager', tone: 'warning' },
  { id: 'self_service', tone: 'success' },
  { id: 'finance', tone: 'pending' },
  { id: 'exec_read', tone: 'muted' },
  { id: 'audit', tone: 'accent' },
];
